import React from "react";
import { Grid, Container } from "@mui/material";
import PasswordResetForm from "./PasswordResetForm";
import TopBreadcrumb from "../../components/TopBreadcrumb";
import SideMenu from "../../components/SideMenu";
import { useAuthStore } from "../../store/useAuthStore";

const ResetPassword = () => {
    const { authUser } = useAuthStore()
    return (
        <>
            <Container maxWidth="xl">
                <TopBreadcrumb />
                <Grid container sx={{ width: "100%", marginBottom: "70px" }} spacing={4}>
                    <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 2 }}>
                        <SideMenu />
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 12, md: 9, lg: 10 }}>
                        <PasswordResetForm />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default ResetPassword;
